import { RunScenarioInput } from 'views/playground/features/scenario-planner-2.0/types/run-scenario-input.type';

export const runScenario = (request: RunScenarioInput): Promise<string> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve('200');
    }, 3000); // 3-second delay
  });
};
